import React, { useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import DebitSuccessModal from "components/layout/DebitSuccessModal";
import DirectDebitForm from "components/MI/DirectDebitForm";
import GenericDebit from "components/layout/DebitErrorModal";
import { banks } from "components/MI/DirectDebitForm/banks";
import { toggleNewUnitStep } from "store/actions/add-new-unit-actions";

import { Body, Container, Header } from "./styles";

const DirectDebit = (): JSX.Element => {
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>();
  const [openErrorModal, setOpenErrorModal] = useState<boolean>();
  const [selectedBank, setSelectedBank] = useState(null);
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const dispatch = useDispatch();

  const handleSuccessSubmit = (): void => {
    setOpenSuccessModal(true);
  };

  const handleSubmitErrorAction = (err): void => {
    if (err.response) {
      const erro = err.response.data;
      if (erro) {
        const { message } = err.response.data;
        const { code } = err.response.data;
        if (err.response.status !== 401 && code !== "422.033") {
          toast.error(message);
        } else {
          setOpenErrorModal(true);
        }
      } else {
        toast.error("Ocorreu um erro interno na aplicação");
      }
    } else {
      setOpenErrorModal(true);
    }
  };

  const handleSkipDirectDebit = (): void => {
    dispatch(toggleNewUnitStep(4));
  };

  const closeSuccessModal = (): void => {
    dispatch(toggleNewUnitStep(4));
    setOpenSuccessModal(false);
  };

  const message = useMemo(() => {
    if (selectedBank) {
      const mensagem = banks?.find(
        (bank) => bank?.code === selectedBank
      )?.mensagem;
      if (mensagem) {
        return mensagem;
      }
      return "";
    }
    return "";
  }, [selectedBank, banks]);

  return (
    <Container>
      <Header>
        <h1>Débito automático</h1>
      </Header>

      <Body>
        <DirectDebitForm
          unit={selectedUnit}
          // @ts-ignore
          setSelectedBank={setSelectedBank}
          handleSubmitErrorAction={handleSubmitErrorAction}
          handleSubmitAction={handleSuccessSubmit}
          handleCancelAction={handleSkipDirectDebit}
          cancelButtonText="Pular e concluir"
        />
      </Body>

      <DebitSuccessModal
        openModal={openSuccessModal}
        modalFunction={closeSuccessModal}
        text={message}
      />

      <GenericDebit
        openModal={openErrorModal}
        modalFunction={setOpenErrorModal}
      />
    </Container>
  );
};

export default DirectDebit;
